import { EzStaticClass } from '/ezlibrary/EzStaticClass.js';

/*import { EzObject } from '/ezlibrary/helpers/EzObject.js';*/
/*import { EzBoolean } from '/ezlibrary/helpers/EzBoolean.js';*/
import { EzNumber } from '/ezlibrary/helpers/EzNumber.js';
/*import { EzString } from '/ezlibrary/helpers/EzString.js';*/

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ENGINEERING NOTES
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        1) Do not import anything from /ezlibrary/helpers/EzHelpers.js into this module
        2) Do not import the following into this module:
            import { EzApi } from '/public/common/javascript/ezapi.js';
            import { EzUI } from '/public/common/javascript/ezui.js';
            import { ezUI } from '/public/common/javascript/ezui.js';
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/

/**
 * @exported
 * @public @constant
 * A key/value object of day in month = day (number)
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into non-helper classes with:
 *      import {
 *          // ... other helper class imports
 *          DAY_IN_MONTH
 *      } from '/ezlibrary/helpers/EzHelpers.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into other helper classes with:
 *     import { DAY_IN_MONTH } from '/ezlibrary/helpers/EzDays.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Static Access Only:
 *     DAY_IN_MONTH.DAY{1..31)
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * @returns {object}
 */
export const DAY_IN_MONTH = {
    DAY1: EzNumber.ONE,
    DAY2: EzNumber.TWO,
    DAY3: EzNumber.THREE,
    DAY4: EzNumber.FOUR,
    DAY5: EzNumber.FIVE,
    DAY6: EzNumber.SIX,
    DAY7: EzNumber.SEVEN,
    DAY8: EzNumber.EIGHT,
    DAY9: EzNumber.NINE,
    DAY10: EzNumber.TEN,
    DAY11: 11,
    DAY12: EzNumber.TWELEVE,
    DAY13: EzNumber.THIRTEEN,
    DAY14: 14,
    DAY15: EzNumber.FIFTEEN,
    DAY16: 16,
    DAY17: EzNumber.SEVENTEEN,
    DAY18: 18,
    DAY19: 19,
    DAY20: 20,
    DAY21: 21,
    DAY22: 22,
    DAY23: EzNumber.TWENTY_THREE,
    DAY24: EzNumber.TWENTY_FOUR,
    DAY25: 25,
    DAY26: 26,
    DAY27: 27,
    DAY28: 28,
    DAY29: 29,
    DAY30: EzNumber.THIRTY,
    DAY31: EzNumber.THIRTY_ONE
};

/**
 * @exported
 * @class
 * @extends {EzStaticClass}
 * @description
 * Day of week constants and utilities.
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into non-helper classes with:
 *      import {
 *          // ... other helper class imports
 *          EzDays
 *      } from '/ezlibrary/helpers/EzHelpers.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into other helper classes with:
 *     import { EzDays } from '/ezlibrary/helpers/EzDays.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Static Access Only:
 *     EzDays.{property or method}
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzDays extends EzStaticClass {
    static get DAY0() {
        return EzNumber.ZERO;
    }
    static get ZERO() {
        return EzDays.DAY0;
    }

    static get DAY1() {
        return DAY_IN_MONTH.DAY1;
    }
    static get ONE() {
        return EzDays.DAY1;
    }

    static get DAY2() {
        return DAY_IN_MONTH.DAY2;
    }
    static get TWO() {
        return EzDays.DAY2;
    }

    static get DAY3() {
        return DAY_IN_MONTH.DAY3;
    }
    static get THREE() {
        return EzDays.DAY3;
    }

    static get DAY4() {
        return DAY_IN_MONTH.DAY4;
    }
    static get FOUR() {
        return EzDays.DAY4;
    }

    static get DAY5() {
        return DAY_IN_MONTH.DAY5;
    }
    static get FIVE() {
        return EzDays.DAY5;
    }

    static get DAY6() {
        return DAY_IN_MONTH.DAY6;
    }
    static get SIX() {
        return EzDays.DAY6;
    }

    static get DAY7() {
        return DAY_IN_MONTH.DAY7;
    }
    static get SEVEN() {
        return EzDays.DAY7;
    }

    static get DAY8() {
        return DAY_IN_MONTH.DAY8;
    }
    static get EIGHT() {
        return EzDays.DAY8;
    }

    static get DAY9() {
        return DAY_IN_MONTH.DAY9;
    }
    static get NINE() {
        return EzDays.DAY9;
    }

    static get DAY10() {
        return DAY_IN_MONTH.DAY10;
    }
    static get TEN() {
        return EzDays.DAY10;
    }

    static get DAY11() {
        return DAY_IN_MONTH.DAY11;
    }
    static get ELEVEN() {
        return EzDays.DAY11;
    }

    static get DAY12() {
        return DAY_IN_MONTH.DAY12;
    }
    static get TWELVE() {
        return EzDays.DAY12;
    }

    static get DAY13() {
        return DAY_IN_MONTH.DAY13;
    }
    static get THIRTEEN() {
        return EzDays.DAY13;
    }

    static get DAY14() {
        return DAY_IN_MONTH.DAY14;
    }
    static get FOURTEEN() {
        return EzDays.DAY14;
    }

    static get DAY15() {
        return DAY_IN_MONTH.DAY15;
    }
    static get FIFTEEN() {
        return EzDays.DAY15;
    }

    static get DAY16() {
        return DAY_IN_MONTH.DAY16;
    }
    static get SIXTEEN() {
        return EzDays.DAY16;
    }

    static get DAY17() {
        return DAY_IN_MONTH.DAY17;
    }
    static get SEVENTEEN() {
        return EzDays.DAY17;
    }

    static get DAY18() {
        return DAY_IN_MONTH.DAY18;
    }
    static get EIGHTEEN() {
        return EzDays.DAY18;
    }

    static get DAY19() {
        return DAY_IN_MONTH.DAY19;
    }
    static get NINETEEN() {
        return EzDays.DAY19;
    }

    static get DAY20() {
        return DAY_IN_MONTH.DAY20;
    }
    static get TWENTY() {
        return EzDays.DAY20;
    }

    static get DAY21() {
        return DAY_IN_MONTH.DAY21;
    }
    static get TWENTY_ONE() {
        return EzDays.DAY21;
    }

    static get DAY22() {
        return DAY_IN_MONTH.DAY22;
    }
    static get TWENTY_TWO() {
        return EzDays.DAY22;
    }

    static get DAY23() {
        return DAY_IN_MONTH.DAY23;
    }
    static get TWENTY_THREE() {
        return EzDays.DAY23;
    }

    static get DAY24() {
        return DAY_IN_MONTH.DAY24;
    }
    static get TWENTY_FOUR() {
        return EzDays.DAY24;
    }

    static get DAY25() {
        return DAY_IN_MONTH.DAY25;
    }
    static get TWENTY_FIVE() {
        return EzDays.DAY25;
    }

    static get DAY26() {
        return DAY_IN_MONTH.DAY26;
    }
    static get TWENTY_SIX() {
        return EzDays.DAY26;
    }

    static get DAY27() {
        return DAY_IN_MONTH.DAY27;
    }
    static get TWENTY_SEVEN() {
        return EzDays.DAY27;
    }

    static get DAY28() {
        return DAY_IN_MONTH.DAY28;
    }
    static get TWENTY_EIGHT() {
        return EzDays.DAY28;
    }

    static get DAY29() {
        return DAY_IN_MONTH.DAY29;
    }
    static get TWENTY_NINE() {
        return EzDays.DAY29;
    }

    static get DAY30() {
        return DAY_IN_MONTH.DAY30;
    }
    static get THIRTY() {
        return EzDays.DAY30;
    }

    static get DAY31() {
        return DAY_IN_MONTH.DAY31;
    }
    static get THIRTY_ONE() {
        return EzDays.DAY31;
    }

    static get DAYS_IN_WEEK() {
        return DAY_IN_MONTH.DAY7;
    }

    static get ONE_WEEK_DAYS() {
        return EzDays.DAYS_IN_WEEK;
    }

    static get TWO_WEEKS_DAYS() {
        return EzDays.daysInWeeks(EzNumber.TWO);
    }

    static get THREE_WEEKS_DAYS() {
        return EzDays.daysInWeeks(EzNumber.THREE);
    }

    static get FOUR_WEEKS_DAYS() {
        return EzDays.daysInWeeks(EzNumber.FOUR);
    }

    static daysInWeeks(numberOfWeeks) {
        return EzDays.DAYS_IN_WEEK * numberOfWeeks;
    }
}
